<template>
  <div>
    <section class="container-mask form-wrap" style="z-index: 100;">
      <div class="container form-mask" style="max-width: 60rem">
        <div class="iconf close-iconf" @click="closeTalkAdvise"></div>
        <div action="" onsubmit="return false" class="form-container form ui ">
          <h2 class="c1" style="text-align: center;">Talk to a LightCourse advisor</h2>
          <div class="m-box" style="display: flex">
            <div class="m-item">
              <h5>Option 1</h5>
              <p>Please scan the WeChat QR Code to add our academic advisor and receive additional details.</p>
              <img style="width:150px; display:block; margin: 0 auto; float:left;" :src='this.$store.state.baseURL + "/new/images/wwww.jpg"'>
            </div>
            <div class="line"></div>
            <div class="m-item">
              <h5>Option 2</h5>
              <p>LightCourse has extensive transfer credit experience and can help students understand their home
                institution’s transfer credit policies. However, the acceptance of transfer credits is
                determined by the sutdent’s home institution.</p>
              <p>Your LightCourse advisor will contact you via email within 24 hours.</p>
              <form action="">
                <div class="field">
                  <input type="text" v-model="form.uniName" name="school" id="school" placeholder="Please enter the name of your school*">
                </div>
<!--                <input type="hidden" name="fb_code" id="fb_code" value="{$goods.goods_serial}">-->
<!--                <input type="hidden" name="fb_course" id="fb_course" value="{$goods.goods_name}">-->
<!--                <input type="hidden" name="fb_school" id="fb_school" value="{$goods.ke_college}">-->
                <p>Please tell us your name</p>
                <div class="fields two">
                  <div class="field">
                    <input type="text" v-model="form.firstName" name="fname" id="fname" placeholder="First name*">
                  </div>
                  <div class="field">
                    <input type="text" v-model="form.lastName" name="lname" id="lname" placeholder="Last name*">
                  </div>
                </div>
                <div class="field">
                  <input type="text" v-model="form.email" name="email" id="email" placeholder="What email address can we reach you at?">
                </div>
                <div class="c">
                  <p>If you require immediate assistance, please contact us at
                    <a href="mailto:studentservice@lightglobal.org"><strong class="c1">studentservice@lightglobal.org</strong></a>
                  </p>
                </div>
                <div class="sub">
                  <button type="submit" @click="submit" class="ui primary button onsubmitfromss">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
	</div>
</template>

<script>
  import {submitRequire} from "../../api/course";

  export default {
    props: {

    },
    data(){
      return{
        form: {
          email: null,
          firstName: null,
          lastName: null,
          uniName: null,
        }
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      async submit() {
        if (this.form.email == null || this.form.email == "") {
          layer.msg("email can not be empty");
          return;
        }
        let result = await submitRequire(this.form);
        if (result.code == 200) {
          layer.msg("Submit Succeeded");
        } else {
          layer.msg("Submit Failed");
        }
      },
      openTalkAdvise() {
        $(".container-mask.form-wrap").addClass("show");
      },
      closeTalkAdvise() {
        $(".container-mask.form-wrap").removeClass("show");
      }
    }
  }
</script>

<style scoped>
  .ui.primary.button {
    font-size: 0.9rem;
  }


  .main-QA {
    padding-top: 1rem;
  }

  .m-box {
    margin-top: 35px;
    margin-bottom: 20px;
  }

  .m-item {
    width: 50%;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  .m-box .line {
    margin: 0 10px;
    display: block;
    width: 1px;
  ;
    height: 200px;
    background: #3b52f6;
  }

  .m-item h5 {
    text-align: left;
    font-size: 22px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact/Contact.vue